import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '@mafc/common';

import useDrawerControls from 'hooks/useDrawerControls';
import OrderErrors from 'pages/Checkout/types/orderError.types';
import { dispatchCheckoutError } from 'pages/Checkout/redux/actions/order.action';
import { setPaymentMode } from 'pages/Checkout/redux/actions/payment.action';

const usePlaceOrderError = () => {
  const dispatch = useDispatch();

  const { errorCode, paymentMode, paymentDetails } = useSelector((state: IAppState) => ({
    errorCode: state.checkout.placeOrderError.subject,
    paymentDetails: state.checkout.payment,
    paymentMode: state.cart.cartData.paymentMode,
  }));

  const { isOpen, openDrawer, closeDrawer } = useDrawerControls();

  const isBankDiscountFailed =
    errorCode === OrderErrors.PMV_101 || errorCode === OrderErrors.PMV_102;

  const isDiscountFailed = errorCode === OrderErrors.PMV_103;

  return {
    errorCode,
    isOpen,
    isBankDiscountFailed,
    isDiscountFailed,
    openDrawer,
    closeDrawer: () => {
      dispatch(dispatchCheckoutError({}));
      dispatch(setPaymentMode(paymentMode, paymentDetails));
      closeDrawer();
    },
  };
};

export default usePlaceOrderError;
